'use strict';

exports.__esModule = true;

var _ProductData = require('../dataTypes/ProductData');

var _ProductData2 = _interopRequireDefault(_ProductData);

var _constants = require('../constants');

var _constants2 = _interopRequireDefault(_constants);

var _objectHelpers = require('../../../../objectHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NOT_SET = _constants2.default.common.NOT_SET;

/**
 * This event communicates to GA that a checkout step was reached
 * (think of it like a page hit but for a "page" in the checkout process)
 *
 * @name CheckoutStep
 * @param {Object} params - see spread params for more info
 * @param {ProductData[]} params.products - list of products in cart (passed along with each step visited)
 */

var CheckoutStep = function CheckoutStep(_ref) {
    var step = _ref.step,
        option = _ref.option,
        products = _ref.products;

    _classCallCheck(this, CheckoutStep);

    this.event = 'checkout';
    this.ecommerce = {
        checkout: (0, _objectHelpers.removeUndefined)({
            // option not used
            actionField: { step: step, option: option },
            products: products
        })
    };
};

exports.default = CheckoutStep;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/providers/googleTagManager/enhancedEcommerce/CheckoutStep.js
// module id = 856
// module chunks = 0